import { fieldOperationsModuleAvailable, useFieldOperationsSettings } from './context/FieldOperationsSettingsContext';

export {
  FieldOperationsSettingsProvider,
  fieldOperationsModuleAvailable,
  useFieldOperationsSettings,
} from './context/FieldOperationsSettingsContext';

export const useFieldOperationsModuleVisible = (): boolean => {
  const { isModuleEnabled } = useFieldOperationsSettings();
  return fieldOperationsModuleAvailable && isModuleEnabled;
};
